import Content from './components/Content'
import Header from './components/Header'
import Modal from './components/Modal'
import ScrollToTop from './components/ScrollToTop'
import './App.css'
import { BrowserRouter as Router } from "react-router-dom"
import { useState, useEffect } from 'react'

function App() {
  const [searchValue, setSearchValue] = useState("")
  const [showEuropean, setShowEuropean] = useState(true)
  const [filterCategory, setFilterCategory] = useState({
    "vegetable": true, 
    "fruit": true, 
    "berry": true, 
    "root": true, 
    "mushroom": true,
    "herb": true
  })

  // get category and europe filter from local storage
  useEffect(() => {
    let getCategoryFromStorage = localStorage.getItem("category")
    if (getCategoryFromStorage !== null) setFilterCategory(JSON.parse(getCategoryFromStorage))
    let getEuropeFilterFromStorage = localStorage.getItem("european")
    if (getEuropeFilterFromStorage !== null) setShowEuropean(JSON.parse(getEuropeFilterFromStorage))
  }, [])

  // save category to local storage
  useEffect(() => {
    let isCookiesApproved = localStorage.getItem("cookiesApproved")
    isCookiesApproved = JSON.parse(isCookiesApproved)
    if (isCookiesApproved) localStorage.setItem("category", JSON.stringify(filterCategory))
  }, [filterCategory])

  // save europe filter to local storage
  useEffect(() => {
    let isCookiesApproved = localStorage.getItem("cookiesApproved")
    isCookiesApproved = JSON.parse(isCookiesApproved)
    if (isCookiesApproved) localStorage.setItem("european", showEuropean)
  }, [showEuropean])

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Header
          setSearchValue={setSearchValue}
        />
        <Content 
          searchValue={searchValue} 
          showEuropean={showEuropean}
          filterCategory={filterCategory}
        />
        <Modal 
          showEuropean={showEuropean}
          setShowEuropean={setShowEuropean}
          filterCategory={filterCategory}
          setFilterCategory={setFilterCategory}
        />
      </Router>
    </div>
  );
}

export default App
